import { loadStripe } from "@stripe/stripe-js";

const PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Singleton — Stripe recommends loading once at app boundary
export const stripePromise = PUBLISHABLE_KEY ? loadStripe(PUBLISHABLE_KEY) : null;

// Dark-luxury Elements appearance, locked to the Primenax aesthetic
export const stripeAppearance = {
  theme: "night",
  labels: "floating",
  variables: {
    colorPrimary: "#D10000",
    colorBackground: "#0A0A0A",
    colorText: "#FFFFFF",
    colorTextSecondary: "rgba(255,255,255,0.55)",
    colorTextPlaceholder: "rgba(255,255,255,0.35)",
    colorIconTab: "#FFFFFF",
    colorIconTabSelected: "#D10000",
    colorDanger: "#FF5252",
    fontFamily: "Manrope, system-ui, sans-serif",
    fontWeightNormal: "500",
    fontSizeBase: "15px",
    spacingUnit: "5px",
    borderRadius: "2px",
  },
  rules: {
    ".Input": {
      backgroundColor: "transparent",
      border: "1px solid rgba(255,255,255,0.12)",
      boxShadow: "none",
      padding: "14px 14px",
    },
    ".Input:focus": {
      borderColor: "#D10000",
      boxShadow: "0 0 0 1px #D10000",
    },
    ".Label": {
      fontFamily: "Bebas Neue, sans-serif",
      letterSpacing: "0.25em",
      textTransform: "uppercase",
      fontSize: "10px",
      color: "rgba(255,255,255,0.55)",
    },
    ".Tab": {
      backgroundColor: "transparent",
      border: "1px solid rgba(255,255,255,0.12)",
    },
    ".Tab--selected": {
      borderColor: "#D10000",
      backgroundColor: "rgba(209,0,0,0.05)",
    },
    ".Tab:hover": {
      backgroundColor: "rgba(255,255,255,0.04)",
    },
  },
};
